import React, { useEffect } from "react";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { COOKIE_PROFILE } from "../../constants/cookie";
import setWrappedComponent from "../utils/react/setWrappedComponent";
import { refreshProfile } from "../actions/user";
import { isVipSelector, isLoginSelector } from "../selector/user";

/** Check whether the Cookie VIP matches the Redux VIP status in the logged in situation
 * @see https://chocotv.atlassian.net/browse/BUG-16?focusedCommentId=17161
 */
export default function withVIPGuard(WrappedComponent) {
  function VIPGuard(props) {
    const { isLogin, isVip: isVIPInRedux, dispatch } = props;

    useEffect(() => {
      if (isLogin) {
        const cookieProfile = Cookies.get(COOKIE_PROFILE);
        const isVIPInCookie = cookieProfile
          ? JSON.parse(cookieProfile)?.isVip
          : null;

        if (isVIPInCookie !== isVIPInRedux) {
          dispatch(refreshProfile());
        }
      }
    }, [isLogin]);

    return <WrappedComponent {...props} />;
  }

  setWrappedComponent(VIPGuard, WrappedComponent);

  const mapStateToProps = (state) => ({
    isLogin: isLoginSelector(state),
    isVip: isVipSelector(state),
  });

  return connect(mapStateToProps)(VIPGuard);
}
